import { useState } from "react";
import moment from "moment";

export const useDashboardState = () => {
  // Get URL parameters for initial state
  const getUrlParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const monthParam = urlParams.get("month");
    const yearParam = urlParams.get("year");

    return {
      month: monthParam ? parseInt(monthParam) : moment().month() + 1,
      year: yearParam ? yearParam : moment().format("YYYY")
    };
  };

  const urlParams = getUrlParams();

  // State management
  const [month, setMonth] = useState(urlParams.month);
  const [year, setYear] = useState(urlParams.year);
  const [activeKeys, setActiveKeys] = useState(["2"]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [dedicatedNumbers, setDedicatedNumbers] = useState([]);

  return {
    month,
    year,
    setMonth,
    setYear,
    activeKeys,
    setActiveKeys,
    isModalVisible,
    setIsModalVisible,
    visibleDrawer,
    setVisibleDrawer,
    refreshLoading,
    setRefreshLoading,
    dedicatedNumbers,
    setDedicatedNumbers
  };
};
